var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContenItemIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 30.3334H10.6667C5.8 30.3334 3 27.5334 3 22.6667V9.33335C3 4.46669 5.8 1.66669 10.6667 1.66669H21.3333C26.2 1.66669 29 4.46669 29 9.33335V22.6667C29 27.5334 26.2 30.3334 21.3333 30.3334ZM10.6667 3.66669C6.85333 3.66669 5 5.52002 5 9.33335V22.6667C5 26.48 6.85333 28.3334 10.6667 28.3334H21.3333C25.1467 28.3334 27 26.48 27 22.6667V9.33335C27 5.52002 25.1467 3.66669 21.3333 3.66669H10.6667Z",
    fill: "#001F4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6673 12.3333H22.0007C19.974 12.3333 18.334 10.6933 18.334 8.66667V6C18.334 5.45333 18.7873 5 19.334 5C19.8807 5 20.334 5.45333 20.334 6V8.66667C20.334 9.58667 21.0807 10.3333 22.0007 10.3333H24.6673C25.214 10.3333 25.6673 10.7867 25.6673 11.3333C25.6673 11.88 25.214 12.3333 24.6673 12.3333Z",
    fill: "#001F4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 18.3334H10.666C10.1193 18.3334 9.66602 17.88 9.66602 17.3334C9.66602 16.7867 10.1193 16.3334 10.666 16.3334H15.9993C16.546 16.3334 16.9993 16.7867 16.9993 17.3334C16.9993 17.88 16.546 18.3334 15.9993 18.3334Z",
    fill: "#001F4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3327 23.6666H10.666C10.1193 23.6666 9.66602 23.2133 9.66602 22.6666C9.66602 22.12 10.1193 21.6666 10.666 21.6666H21.3327C21.8793 21.6666 22.3327 22.12 22.3327 22.6666C22.3327 23.2133 21.8793 23.6666 21.3327 23.6666Z",
    fill: "#001F4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContenItemIcon);
export default __webpack_public_path__ + "static/media/contenItemIcon.a18dd8d0a329d4d5014fbc6f17e845d4.svg";
export { ForwardRef as ReactComponent };